import Management from 'components/general/Management'
import { formatVND } from 'general_function';
import React, { useEffect, useState } from 'react'
import dayjs from "dayjs";
import { Divider, Skeleton, Table } from 'antd';
import TermHandle from '../UniversityTerms/TermHandle';
import API from 'API';
import FullMask from 'components/layout/FullMask';

const NOW = dayjs();

const layout = [
    [{ label: "Học phí 1 tín chỉ", name: "price", type: "vnd", rules: [{ required: true }] }],
];

const columns = [
    { title: "Mức học phí 1 tín chỉ", dataIndex: "price", key: "price", render: value => formatVND(value) + " ₫" },
    {
        title: "Áp dụng", dataIndex: "created_at", key: "price", render: (value, record, index) => {
            if (index === 0) {
                return `${dayjs(value).format("DD/MM/YYYY HH:mm:ss")} - Hiện tại`;
            }
            return `${dayjs(value).format("DD/MM/YYYY HH:mm:ss")} - ${dayjs(record[index]).format("DD/MM/YYYY HH:mm:ss")}`;
        }
    },
    { title: "Tổng học phí đã thu", dataIndex: "count", key: "count", render: (value, record) => formatVND(value * record["price"]) + " ₫" }
]

const coursesColumns = [
    { title: "Mã môn", dataIndex: "course__code", key: "course__code" },
    { title: "Tên môn", dataIndex: "course__name", key: "course__name" },
    { title: "Tổng học phí", dataIndex: "total", key: "total", render: (value) => formatVND(value) + " ₫", width: 200 },
    { title: "Tổng sinh viên", dataIndex: "count", key: "count", width: 200 },
]

const studentsColumns = [
    { title: "Mã sinh viên", dataIndex: "student__student_number", key: "student__student_number"},
    { title: "Tên sinh viên", dataIndex: "student__first_name", key: "full_name", render: (value, record) => <>{record.student__last_name} {value}</>},
    { title: "Tổng học phí", dataIndex: "total", key: "total", render: (value) => formatVND(value) + " ₫", width: 200 },
    { title: "Tổng môn học", dataIndex: "count", key: "count", width: 200 },
]

const createdBysColumns = [
    { title: "Nguồn", dataIndex: "created_by__first_name", key: "full_name", render: (value, record) => 
    value === null ? "Tự đăng ký" : <>{record.created_by__last_name} {value}</>},
    { title: "Tổng học phí", dataIndex: "total", key: "total", render: (value) => formatVND(value) + " ₫", width: 200 },
    { title: "Tổng đăng ký", dataIndex: "count", key: "count", width: 200 },
]

export default function UniversityTuition() {
    const [terms, setTerms] = useState(null);
    const [selectedTerm, setSelecterdTerm] = useState(null);
    const [loading, setLoading] = useState(true);
    const [gettingTuition, setGettingTuition] = useState(false);
    const [total, setTotal] = useState(null);
    useEffect(() => {
        async function getTerm() {
            try {
                const response = await API.get("/terms/", {
                    params: {
                        page_size: 1000
                    }
                });
                var check = false;
                for (const r of response.data.results) {
                    r.start_time = dayjs(r.start_time);
                    r.end_time = dayjs(r.end_time);
                    if (!check) {
                        if (r.start_time.isBefore(NOW) && r.end_time.isAfter(NOW)) {
                            check = true;
                            setSelecterdTerm(r);
                        }
                    }
                }
                if (!check) {
                    setSelecterdTerm(response.data.results[0] || null);
                }
                setTerms(response.data.results);
                setLoading(false);
            } catch (e) {
                console.log(e);
            } finally {

            }
        }
        getTerm();
    }, [])
    useEffect(() => {
        async function getTuition() {
            if (!selectedTerm) {
                return;
            }
            try {
                setGettingTuition(true);
                const response = await API.post("/get-total-price/", { term_id: selectedTerm.id });
                setTotal(response.data);
            } catch (e) {
                console.log(e);
            } finally {
                setGettingTuition(false);
            }
        }
        getTuition();
        // eslint-disable-next-line
    }, [selectedTerm?.id])
    return <>
        <Management
            layout={layout}
            columns={columns}
            apiPath="/prices/"
            itemName="học phí tín chỉ"
            disableSearch
            customActions={() => { }}
        />
        <Divider />
        {loading ? <Skeleton active /> : <div style={{ position: "relative" }}>
            {gettingTuition && <FullMask page />}
            <h5>Chọn kỳ:</h5>
            <TermHandle terms={terms} setTerms={setTerms} edit={false}
                selectedTerm={selectedTerm} setSelecterdTerm={setSelecterdTerm} />
            {total && <div>
                <ul>
                    <li><b>Tổng học phí:</b> {formatVND(total.total.total)} ₫</li>
                    <li><b>Tổng số đăng ký:</b> {total.total.count}</li>
                </ul>
                <Table 
                    rowKey="course__code"
                    dataSource={total.courses}
                    columns={coursesColumns}
                />
                <Table
                    rowKey="student_id"
                    dataSource={total.students}
                    columns={studentsColumns}
                />
                <Table
                    rowKey="created_by_id"
                    dataSource={total.created_bys}
                    columns={createdBysColumns  }
                />
            </div>}
        </div>
        }
    </>
}
